"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentStatus = exports.IdentityDocumentType = exports.DocumentType = void 0;
var DocumentType;
(function (DocumentType) {
    DocumentType["IDENTITY_DOCUMENT"] = "IDENTITY_DOCUMENT";
    DocumentType["ADDRESS"] = "ADDRESS";
    DocumentType["PAYMENT"] = "PAYMENT";
})(DocumentType || (exports.DocumentType = DocumentType = {}));
var IdentityDocumentType;
(function (IdentityDocumentType) {
    IdentityDocumentType["NATIONAL_ID_CARD"] = "NATIONAL_ID_CARD";
    IdentityDocumentType["INTERNATIONAL_PASSPORT"] = "INTERNATIONAL_PASSPORT";
    IdentityDocumentType["DRIVER_LICENSE"] = "DRIVER_LICENSE";
})(IdentityDocumentType || (exports.IdentityDocumentType = IdentityDocumentType = {}));
var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["PENDING"] = "PENDING";
    DocumentStatus["REJECTED"] = "REJECTED";
    DocumentStatus["APPROVED"] = "APPROVED";
})(DocumentStatus || (exports.DocumentStatus = DocumentStatus = {}));
//# sourceMappingURL=document.js.map